var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "page-editor-ui": "static-1.32507",
      "apollo-dlb": "static-3.41",
      "backbone": "static-1.6",
      "client-types": "static-1.373",
      "codemirror-dlb": "static-1.53504",
      "collaboration-sidebar": "static-1.52706",
      "ContentComponents": "static-2.66358",
      "ContentData": "static-1.63477",
      "ContentEditorUI": "static-2.71948",
      "ContentUtils": "static-1.63401",
      "customer-agent-discovery-components-lib": "static-1.776",
      "data-fetching-client": "static-1.8443",
      "editor-components": "static-1.11853",
      "emoji-mart": "static-3.4",
      "FileManagerLib": "static-1.34419",
      "foundations-assets": "static-1.3755",
      "foundations-components": "static-1.6032",
      "head-dlb": "static-1.4003",
      "hs-test-utils": "static-1.6828",
      "hub-http": "static-1.4807",
      "hub-http-shared-msw-handlers": "static-1.7097",
      "hubspot-dlb": "static-2.1406",
      "HubStyleTokens": "static-2.10326",
      "I18n": "static-7.1391",
      "InpageEditorUI": "static-1.80390",
      "jasmine-immutable": "static-1.1795",
      "jasmine-runner": "static-1.5232",
      "layout-dnd-utils": "static-1.9734",
      "personalization-lib": "static-1.1781",
      "quartz": "static-1.5582",
      "react-dlb": "static-1.53",
      "react-dnd": "static-4.51",
      "react-dnd-html5-backend": "static-4.5",
      "react-redux": "static-7.16",
      "react-router-dom": "static-5.26",
      "react-utils": "static-2.4345",
      "redux-thunk": "static-2.43",
      "settings-ui-lib": "static-1.11380",
      "sinon": "static-1.9",
      "tinymce": "static-6.5",
      "ui-addon-draggable": "static-1.4364",
      "ui-components-test-utils": "static-1.4464",
      "ui-images": "static-2.840",
      "ui-memberships-settings-lib": "static-1.28742",
      "video-components-external": "static-1.6038",
      "webpack-env": "static-1.54",
      "ai-components-ui-library": "static-1.5270",
      "apollo-stack-hubspot": "static-3.43",
      "asset-actions-lib": "static-1.40161",
      "atom": "static-1.4034",
      "blueimp-md5": "static-1.8",
      "campaigns-lib": "static-1.22509",
      "classnames": "static-2.10",
      "content-assistance-lib": "static-1.6333",
      "content-management-actions-lib": "static-1.22761",
      "content-management-data-lib": "static-1.3907",
      "content-management-restrictions-lib": "static-1.3632",
      "copilot-plugins": "static-1.6505",
      "copilot-toolkit": "static-1.6532",
      "cropperjs": "static-1.10",
      "cssUtils": "static-1.500",
      "cta-picker": "static-1.31734",
      "customer-data-objects": "static-1.6443",
      "customer-data-objects-ui-components": "static-1.11718",
      "customer-data-properties": "static-1.46010",
      "customer-data-property-utils": "static-1.6756",
      "customer-data-reference-ui-components": "static-1.11825",
      "customer-data-ui-utilities": "static-1.8552",
      "data-token-picker": "static-1.14154",
      "data-token-views": "static-1.14135",
      "error-messaging-js": "static-1.4121",
      "feedback-loader": "static-1.26601",
      "file-manager-components": "static-1.18778",
      "FileManagerCore": "static-1.34278",
      "FormsCommonComponents": "static-1.81242",
      "foundations-theming": "static-1.3149",
      "fuzzy": "static-1.8",
      "growth-onboarding-confetti": "static-1.1932",
      "growth-payments-core": "static-1.21271",
      "history": "static-4.47",
      "hs-lodash": "static-4.45",
      "hs-promise-utils": "static-1.4357",
      "hub-http-contrib": "static-1.1996",
      "hubspot-url-utils": "static-1.3063",
      "HubStyle": "static-2.10634",
      "icons": "static-2.592",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "InboxConnectUtils": "static-4.9903",
      "integrations-lib": "static-1.10694",
      "interframe": "static-3.3628",
      "laboratory-lib": "static-3.6083",
      "layout-data-lib": "static-1.8059",
      "media-bridge-lib": "static-1.16757",
      "nav-meta": "static-1.25561",
      "object-builder-ui-client": "static-1.42480",
      "onboarding-scopes": "static-1.5384",
      "onboarding-tours": "static-1.14411",
      "onboarding-tours-client": "static-1.3326",
      "outpost": "static-1.3187",
      "page-lib": "static-1.16503",
      "PatternValidationJS": "static-1.437",
      "payment-link-components": "static-1.18863",
      "payments-post-enroll-local-storage-lib": "static-1.3928",
      "pictos": "static-7.160",
      "PortalIdParser": "static-2.284",
      "products-ui-components": "static-1.35597",
      "property-translator": "static-1.4218",
      "quick-fetch": "static-1.2772",
      "raven": "static-3.4766",
      "react": "static-7.151",
      "react-beautiful-dnd": "static-1.13",
      "react-colorpicker": "static-2.9075",
      "react-dom": "static-7.85",
      "react-flip-move": "static-1.47",
      "react-immutable-proptypes": "static-2.8",
      "react-input-autosize": "static-2.17",
      "react-rhumb": "static-1.15408",
      "react-select-plus": "static-1.65",
      "react-tinymce": "static-1.50768",
      "react-transition-group": "static-1.7",
      "react-virtualized": "static-2.74",
      "redux": "static-4.16",
      "redux-request-state": "static-1.9407",
      "reference-resolvers": "static-1.6976",
      "reference-resolvers-lite": "static-1.6813",
      "reselect": "static-2.16",
      "rich-text-lib": "static-1.17490",
      "rpc-client-utils": "static-1.3544",
      "sanitize": "static-1.3213",
      "sanitize-text": "static-1.7003",
      "seamless-immutable": "static-7.6",
      "self-service-api": "static-1.9035",
      "SharedI18nStrings": "static-1.162",
      "SharedLegalStrings": "static-1.1310",
      "simple-menus-core": "static-1.13588",
      "simple-menus-lib": "static-1.15105",
      "smart-content-lib": "static-1.38268",
      "styled-components": "static-2.64",
      "StyleGuideUI": "static-3.461",
      "superstore": "static-1.3597",
      "theme-previewer-lib": "static-1.48348",
      "tinymce-config": "static-2.49894",
      "tinymce-copilot": "static-1.11962",
      "tinymce-data": "static-1.35979",
      "tinymce-plugins": "static-1.53008",
      "tinymce-themes": "static-1.51864",
      "transmute": "static-2.29",
      "ui-addon-avatars": "static-2.8156",
      "ui-addon-emoji-picker": "static-1.8772",
      "ui-addon-form-validation": "static-1.9850",
      "ui-addon-i18n": "static-1.9752",
      "ui-addon-iframeable": "static-1.7722",
      "ui-addon-opt": "static-4.7463",
      "ui-addon-sales-email": "static-1.4043",
      "ui-addon-upgrades": "static-9.16083",
      "ui-business-units-lib": "static-1.7705",
      "ui-gdpr-components": "static-1.9072",
      "ui-product-approvals": "static-1.23965",
      "ui-shepherd-react": "static-3.8893",
      "ui-suspension-banners-lib": "static-1.5250",
      "UIComponents": "static-3.7273",
      "underscore": "static-1.8",
      "urlinator": "static-1.3377",
      "usage-tracker": "static-1.6297",
      "usage-tracker-core": "static-1.6147",
      "user-context": "static-1.4002",
      "video-embed": "static-1.30530",
      "web-interactives-components": "static-1.11564",
      "web-interactives-data": "static-1.11565",
      "wootric-nps": "static-1.5756",
      "xray-recommendation-lib": "static-1.6023",
      "codemirror": "static-5.72",
      "react-codemirror": "static-1.9435",
      "enviro": "static-4.306",
      "hs-promise-rejection-tracking": "static-1.4306",
      "raven-hubspot": "static-1.5073",
      "hoist-non-react-statics": "static-3.9",
      "metrics-js": "static-1.8459",
      "bend-plugin-trellis-migration": "static-1.2474",
      "moment": "static-3.26",
      "jquery": "static-3.6",
      "chatspot-client-types": "static-1.8627",
      "chatspot-core": "static-1.15770",
      "chatspot-widget-iframe": "static-1.15764",
      "framework-data-schema-resolvers": "static-1.5701",
      "frontend-preferences-client": "static-1.6697",
      "graphql": "static-1.59",
      "magpie-lib": "static-1.4498",
      "magpie-types": "static-1.3958",
      "quartz-core": "static-1.4801",
      "simple-logging-lib": "static-1.1867",
      "ts-schema": "static-1.3154",
      "cms-field-types": "static-1.3615",
      "content-embed-lib": "static-1.6182",
      "ExportDialog": "static-6.9215",
      "forms-utils-lib": "static-1.10267",
      "integrations-error-boundary-lib": "static-1.8109",
      "payments-embed-points-lib": "static-1.9582",
      "react-dnd-compat": "static-1.3484",
      "usage-tracker-container": "static-1.6287",
      "video-data-lib": "static-1.29689",
      "videoconference-integration-components": "static-1.4981",
      "editor-iframe-lib": "static-1.7138",
      "FireAlarmUi": "static-1.3655",
      "hubspot-apollo-client": "static-1.3655",
      "layout-dnd-components": "static-1.10759",
      "marketing-email-service-types": "static-1.1449",
      "smart-content-core": "static-1.37615",
      "social-composer-lib": "static-1.53555",
      "structured-content-lib": "static-1.20526",
      "timezone-utils": "static-2.4072",
      "ui-active-theme-content-creator-lib": "static-1.32416",
      "ui-addon-video-player": "static-1.7598",
      "ui-asset-management-lib": "static-1.9111",
      "ui-tool-access": "static-1.8886",
      "content-icons-ui": "static-1.1897",
      "react-aria": "static-1.39",
      "FileManagerImages": "static-1.31929",
      "hs-story-utils": "static-1.8220",
      "bend-plugin-foundations-components": "static-1.2301",
      "floating-ui": "static-1.29",
      "foundations-theming-specialty": "static-1.866",
      "framer-motion": "static-1.41",
      "tanstack-table": "static-1.23",
      "ui-fonts": "static-1.332",
      "HeadJS": "static-2.577",
      "hs-test-utils-bend-plugin": "static-1.1939",
      "msw": "static-1.39",
      "testing-library": "static-1.121",
      "i18n-data": "static-1.197",
      "moment-timezone": "static-5.51",
      "NamespacedHubStyle": "static-2.8243",
      "react-dnd-ipeui-backend": "static-1.898",
      "ui-coaching-tips": "static-1.23106",
      "jasmine": "static-4.3168",
      "marketplace-embed": "static-1.16844",
      "quartz-core-utils": "static-1.2449",
      "flux-actions": "static-1.273",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.9299",
      "rxjs": "static-5.10",
      "foundations-components-test-utils": "static-1.3517",
      "apollo-link-hub-http": "static-2.3609",
      "content-media-compositions": "static-2.10419",
      "idb-keyval": "static-1.21",
      "immerable": "static-1.2977",
      "video-components": "static-1.8041",
      "autolinker": "static-3.11",
      "foundations-theming-base": "static-1.2134",
      "sassPrefix": "static-1.131",
      "marketing-platform-lib": "static-1.5512",
      "attribution-lib": "static-1.37838",
      "campaigns-build-lib": "static-1.8196",
      "crm-pipelines-api-client-types": "static-1.3146",
      "reporting-ui-components": "static-2.59175",
      "ai-rendering-library": "static-1.5282",
      "ui-brand-identity-lib": "static-1.8948",
      "avatar-components": "static-1.1261",
      "calling-cross-tab-library": "static-1.18040",
      "calling-lifecycle-messages": "static-1.51752",
      "commerce-products-lib": "static-1.5077",
      "conditional-properties-service-client": "static-1.2938",
      "crm-links": "static-1.4932",
      "crm-message-bus": "static-1.36974",
      "external-options-client-types": "static-1.3103",
      "google-libphonenumber": "static-1.12",
      "inbound-db-meta-service-client": "static-1.2807",
      "inbound-db-properties-service-client": "static-1.2950",
      "inbounddb-objects-service-types": "static-1.3232",
      "pipeline-validation-client-types": "static-1.2894",
      "smart-property-lib": "static-1.941",
      "react-immutable-render-mixin": "static-1.9",
      "audio-components": "static-1.4488",
      "redux-toolkit": "static-1.7",
      "salesImages": "static-1.500",
      "forms-ai-lib": "static-1.2274",
      "bend-plugin-foundations-theming": "static-1.1632",
      "commerce-analytics-service-client": "static-1.2535",
      "integrations-tracking-lib": "static-1.4338",
      "native-integrations-shared-strings": "static-1.6667",
      "getting-started-shared-tasks": "static-1.12800",
      "growth-data-modal": "static-1.4054",
      "navigation-components": "static-1.13924",
      "ui-shepherd-tracker": "static-1.6274",
      "ui-universal-auth": "static-1.7625",
      "commerce-tours-lib": "static-1.3646",
      "growth-onboarding-reliability": "static-1.3985",
      "sales-checkout-service-client": "static-1.2547",
      "commerce-shared-components-lib": "static-1.14855",
      "commerce-subscription-lib": "static-1.31634",
      "crm_components": "static-3.86901",
      "crm_data": "static-4.86901",
      "customer-data-filters-ui": "static-1.34083",
      "customer-data-tracking": "static-1.5634",
      "dispatcher": "static-1.112",
      "framework-data-table": "static-2.8703",
      "property-description-translator": "static-1.2679",
      "csstype": "static-1.38",
      "batch-promise": "static-1.420",
      "fast-json-stable-stringify": "static-1.4",
      "commerce-tools-ui-lib": "static-1.6787",
      "redux-mock-store": "static-1.8",
      "redux-undo": "static-1.10",
      "hubspotter-http": "static-1.3603",
      "navigation-messaging": "static-1.3251",
      "feature-store-service-types": "static-1.3510",
      "growth-monetization-service-types": "static-1.3517",
      "upgrade-management-service-types": "static-1.3501",
      "getting-started-shared-tasks-store": "static-1.11918",
      "diff-match-patch": "static-1.7",
      "browser-eslint": "static-2.57",
      "framework-builder-read-service-client": "static-1.3075",
      "framework-data-schema-quick-fetch": "static-1.5606",
      "persist-promise": "static-1.2578",
      "hub-http-janus": "static-1.648",
      "general-store": "static-6.20",
      "hubspotter-http-shared-msw-handlers": "static-1.7095",
      "mobile-manifest-mixins": "static-1.348",
      "platform-navigation-bootstrap": "static-1.11240",
      "payments-enrollment-embed-lib": "static-1.17853",
      "growth-onboarding-feedback-components": "static-1.5277",
      "marketplace-ui-apps-core": "static-1.12987",
      "marketplace-ui-client-types": "static-1.11858",
      "marketplace-ui-common": "static-1.14451",
      "marketplace-ui-details": "static-1.4351",
      "property-management-iframe": "static-1.8448",
      "trellis-ecosystem": "static-1.4717",
      "social-insights-client-types": "static-1.17865",
      "FormUrlGenerator": "static-2.3552",
      "highcharts": "static-8.81",
      "report-customization-components": "static-1.8961",
      "reporting-action-components": "static-1.36492",
      "reporting-data": "static-1.61898",
      "reporting-enablement": "static-1.17353",
      "reporting-snowflake": "static-1.50519",
      "reporting-visualizations": "static-1.53975",
      "customer-data-filters": "static-1.47898",
      "reporting-plugins": "static-1.7003",
      "reporting-reports": "static-1.61581",
      "highlight.js": "static-1.45",
      "markdown-it": "static-1.6",
      "react-table": "static-1.15",
      "ui-addon-teams": "static-1.19824",
      "calling-internal-common": "static-1.30058",
      "shared-worker-versioning": "static-1.9905",
      "calling-global-api": "static-1.58075",
      "calling-lifecycle-internal": "static-1.59457",
      "products-iframe-lib": "static-1.3294",
      "products-ui-components-shared-msw-handlers": "static-1.7480",
      "location-customization-utils-lib": "static-1.4184",
      "breeze-intelligence-kit": "static-1.4070",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.7181",
      "fsm": "static-1.2533",
      "policy-lib": "static-1.5619",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.7243",
      "final-form": "static-1.40",
      "universal-page-editor-lib": "static-1.1768",
      "commerce-billing-lib": "static-1.14964",
      "commerce-contract-lib": "static-1.6552",
      "conversations-skeleton-state": "static-1.6214",
      "crm_universal": "static-1.20577",
      "customer-data-content": "static-1.24578",
      "crm_schema": "static-3.86939",
      "customer-data-email": "static-1.15827",
      "customer-data-filters-ui-msw-helpers": "static-1.16516",
      "lodash": "static-4.7",
      "customer-data-associations": "static-1.6035",
      "customer-data-rte": "static-1.29177",
      "cv-backend-services": "static-1.1177",
      "growth-onboarding-empty-states": "static-1.4055",
      "hubspot-prosemirror": "static-1.13815",
      "prosemirror": "static-1.13",
      "qrcode-generator": "static-1.44",
      "quotes-client-types": "static-1.31968",
      "platform-infra-nav-components": "static-1.6711",
      "stripe-embedded-components": "static-1.5287",
      "developer-experience-shared-components": "static-1.9000",
      "immutable-less": "static-1.3386",
      "ui-addon-integrations-directory-panel": "static-2.6826",
      "ui-extensibility-client-types": "static-1.2984",
      "ai-settings-ui-library": "static-1.5951",
      "react-window": "static-1.13",
      "ui-addon-react-router-dom": "static-1.8435",
      "ai-studio-lib": "static-1.5811",
      "embedded-academy-lib": "static-1.10335",
      "marketplace-ui-reviews": "static-1.14410",
      "marketplace-ui-tracking": "static-1.8625",
      "property-management-common": "static-1.734",
      "trellis-story-utils": "static-1.3376",
      "dashboard-lib": "static-1.76071",
      "share-with-third-party-component-lib": "static-1.7496",
      "reporting-client-types": "static-1.1918",
      "data-quality-ui-library": "static-1.8289",
      "html-to-image": "static-1.30",
      "reporting-datasets-permissions-lib": "static-1.7833",
      "crm-object-map": "static-1.2022",
      "deep-diff": "static-1.5",
      "campaign-roi-lib": "static-1.3261",
      "calling-error-reporting": "static-1.30064",
      "calling-usage-tracker": "static-1.5324",
      "calling-orchestration-shared-library": "static-1.30244",
      "multi-currency-client-types": "static-1.2791",
      "sales-views-client-types": "static-1.3144",
      "crm-record-cards-service-types": "static-1.2775",
      "storybook-react": "static-1.4",
      "usage-tracker-session-replay": "static-1.3983",
      "utility-belt": "static-1.1391",
      "crm-cards-sdk": "static-1.38333",
      "zustand": "static-1.51",
      "SalesContentIndexUI": "static-3.7161",
      "sequences-lib": "static-1.5967",
      "draft-content-plugins": "static-1.24535",
      "draft-convert": "static-2.31",
      "draft-extend": "static-2.46",
      "draft-js": "static-5.37",
      "draft-plugins": "static-2.19329",
      "knowledge-content-types": "static-1.7755",
      "stripe-connect-js": "static-1.40",
      "apps-service-types": "static-1.2920",
      "oauth-service-types": "static-1.3132",
      "automation-ui-action-features": "static-1.49964",
      "academy-common-lib": "static-1.9795",
      "crm-component-utils": "static-1.34736",
      "redux-actions": "static-3.7",
      "crm-index-visualization-object-layout": "static-1.731",
      "crm-object-search-query-utilities": "static-1.6384",
      "calling-orchestration-schema": "static-1.30469",
      "amplitude-session-replay-browser": "static-1.33",
      "crm-actions": "static-1.4904",
      "crm-fe-perf": "static-1.21832",
      "sales-templates-service-types-lib": "static-1.3186",
      "sequences-client-types-lib": "static-1.5824",
      "ads-client-types": "static-1.17248",
      "app-users-service-types": "static-1.3366",
      "automation-actions-service-types": "static-1.3333",
      "automation-applications-service-types": "static-1.2553",
      "automation-platform-service-types": "static-1.2139",
      "automation-ui-action-fields": "static-1.33261",
      "automation-ui-associations": "static-1.14847",
      "automation-ui-core": "static-2.16173",
      "automation-ui-enrollment": "static-1.51609",
      "automation-ui-flow-core": "static-1.15562",
      "automation-ui-formula-editor": "static-1.11715",
      "automation-ui-i18n": "static-1.15630",
      "automation-ui-permissions": "static-1.14533",
      "automation-ui-references": "static-1.15585",
      "automation-ui-routing": "static-1.15597",
      "automation-ui-source-apps": "static-1.13319",
      "automation-ui-types": "static-1.14237",
      "automation-ui-usage-tracking": "static-1.15639",
      "crm-properties-common-lib": "static-1.4490",
      "messaging-editing-lib": "static-1.40893",
      "routing-ui": "static-1.16322",
      "skills-lib": "static-1.25158",
      "task-forms-lib": "static-1.36416",
      "ui-addon-automation-embed": "static-1.12371",
      "usage-based-billing-components-lib": "static-1.3999",
      "academy-service-client": "static-1.2688",
      "card-properties-lib": "static-1.39052",
      "customer-data-properties-shared-msw-handlers": "static-1.6425",
      "crm-association-components-lib": "static-1.5169",
      "messaging-publishing-lib": "static-1.40845",
      "mobile-messaging-management-lib": "static-1.29543",
      "automation-enrollment-service-types": "static-1.2715",
      "data-ops-fullstory": "static-1.4171",
      "workflows-copilot-service-types": "static-1.1494",
      "messaging-types-lib": "static-1.40629",
      "short-messages-app-service-client": "static-1.2916",
      "ably": "static-1.18",
      "ably-hubspot-js": "static-2.3406",
      "conversations-http": "static-1.3633",
      "conversations-internal-schema": "static-1.11479",
      "conversations-message-history": "static-1.9932",
      "conversations-prop-types": "static-1.6248",
      "conversations-async-data": "static-2.6499",
      "conversations-error-reporting": "static-1.7775",
      "conversations-infrastructure": "static-1.7763",
      "conversations-thread-data": "static-1.63031",
      "conversations-thread-view": "static-1.71762",
      "conversations-visibility-tools": "static-1.4580",
      "svh-tickets-lib": "static-1.14093",
      "crm-activity-creator-data": "static-1.41441",
      "customer-data-communicator": "static-1.40429",
      "subscription-experience-data-types": "static-1.10918",
      "customer-data-sidebar": "static-2.41256",
      "enrichment-properties-lib": "static-1.10061",
      "framework-listing-lib": "static-2.22864",
      "industries-core": "static-1.5600",
      "messaging-management-lib": "static-1.12405",
      "calling-cross-tab-messaging": "static-1.18037",
      "conversations-internal-pub-sub": "static-1.14833",
      "conversations-routing-lib": "static-1.6625",
      "call-widget-addon": "static-2.28182",
      "calling-integration-cross-tab": "static-1.17870",
      "calling-integration-help-desk": "static-1.19676",
      "calling-ui-library": "static-1.65375",
      "composer-data": "static-1.25811",
      "conversations-inbox-message-history": "static-1.30219",
      "conversations-platform": "static-1.3322",
      "EmailSignatureEditor": "static-1.20778",
      "zorse-crm-components-lib": "static-1.5841",
      "data-model-commons-lib": "static-1.7347",
      "universal-associations-select": "static-1.9641",
      "crm-display-components": "static-1.20486",
      "crm-legacy-global-containers": "static-1.22618",
      "draft-email-branding-plugin": "static-2.20464",
      "draft-signature-plugin": "static-1.20212",
      "hubspot-prosemirror-plugins": "static-1.13807",
      "integration-settings-components": "static-1.10643",
      "outreach-assistant-email-generation": "static-1.3047",
      "sales-email-signature-service-client": "static-1.2811",
      "card-payment-highlight-lib": "static-1.32103",
      "card-subscription-highlight-lib": "static-1.34057",
      "invoices-highlight-card-lib": "static-1.49708",
      "orders-highlight-card-lib": "static-1.17335",
      "products-highlight-card-lib": "static-1.13362",
      "project-storage": "static-1.3516",
      "quotes-highlight-card-lib": "static-1.65885",
      "crm-source-interpretation-lib": "static-1.4108",
      "customer-data-views-management": "static-1.22371",
      "signup-ui-full-screen-search": "static-1.10207",
      "calling-client-interface": "static-1.70614",
      "calling-integration-sdk-support": "static-1.26096",
      "calling-lifecycle-usage-tracker": "static-1.4950",
      "worker-connection-library": "static-1.12247",
      "share-transcript-modal": "static-1.52688",
      "transcript-sidebar": "static-1.63043",
      "twilio-voice-sdk": "static-1.51",
      "conversations-calling-message": "static-1.55155",
      "signup-constants": "static-1.16333",
      "signup-ui-lego-core": "static-1.18343",
      "viral-links-lib": "static-1.5712",
      "remote-ui": "static-1.40",
      "ui-extensions-remote-renderer": "static-1.12741",
      "accounting-integrations-ui-components": "static-1.4933",
      "invoices-iframe-lib": "static-1.51782",
      "invoices-ui-lib": "static-1.49724",
      "SafeStorage": "static-1.3237",
      "quotes-modal-lib": "static-1.96556",
      "quotes-ui-lib": "static-1.74599",
      "crm-export-dialog": "static-1.5120",
      "crm-index-associations-lib": "static-1.5229",
      "ai-addon-copilot-preview": "static-1.4482",
      "recording-review-components-lib": "static-1.26970",
      "call-summary": "static-1.32767",
      "emoji-regex": "static-1.7",
      "signup-ui-url-generator": "static-2.6888",
      "object-comments-thread-lib": "static-1.6326"
    },
    "depPathPrefixes": {
      "page-editor-ui": "/page-editor-ui/static-1.32507",
      "apollo-dlb": "/apollo-dlb/static-3.41",
      "backbone": "/backbone/static-1.6",
      "client-types": "/client-types/static-1.373",
      "codemirror-dlb": "/codemirror-dlb/static-1.53504",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.52706",
      "ContentComponents": "/ContentComponents/static-2.66358",
      "ContentData": "/ContentData/static-1.63477",
      "ContentEditorUI": "/ContentEditorUI/static-2.71948",
      "ContentUtils": "/ContentUtils/static-1.63401",
      "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.776",
      "data-fetching-client": "/data-fetching-client/static-1.8443",
      "editor-components": "/editor-components/static-1.11853",
      "emoji-mart": "/emoji-mart/static-3.4",
      "FileManagerLib": "/FileManagerLib/static-1.34419",
      "foundations-assets": "/foundations-assets/static-1.3755",
      "foundations-components": "/foundations-components/static-1.6032",
      "head-dlb": "/head-dlb/static-1.4003",
      "hs-test-utils": "/hs-test-utils/static-1.6828",
      "hub-http": "/hub-http/static-1.4807",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.7097",
      "hubspot-dlb": "/hubspot-dlb/static-2.1406",
      "HubStyleTokens": "/HubStyleTokens/static-2.10326",
      "I18n": "/I18n/static-7.1391",
      "InpageEditorUI": "/InpageEditorUI/static-1.80390",
      "jasmine-immutable": "/jasmine-immutable/static-1.1795",
      "jasmine-runner": "/jasmine-runner/static-1.5232",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.9734",
      "personalization-lib": "/personalization-lib/static-1.1781",
      "quartz": "/quartz/static-1.5582",
      "react-dlb": "/react-dlb/static-1.53",
      "react-dnd": "/react-dnd/static-4.51",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-4.5",
      "react-redux": "/react-redux/static-7.16",
      "react-router-dom": "/react-router-dom/static-5.26",
      "react-utils": "/react-utils/static-2.4345",
      "redux-thunk": "/redux-thunk/static-2.43",
      "settings-ui-lib": "/settings-ui-lib/static-1.11380",
      "sinon": "/sinon/static-1.9",
      "tinymce": "/tinymce/static-6.5",
      "ui-addon-draggable": "/ui-addon-draggable/static-1.4364",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.4464",
      "ui-images": "/ui-images/static-2.840",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.28742",
      "video-components-external": "/video-components-external/static-1.6038",
      "webpack-env": "/webpack-env/static-1.54",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.5270",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.43",
      "asset-actions-lib": "/asset-actions-lib/static-1.40161",
      "atom": "/atom/static-1.4034",
      "blueimp-md5": "/blueimp-md5/static-1.8",
      "campaigns-lib": "/campaigns-lib/static-1.22509",
      "classnames": "/classnames/static-2.10",
      "content-assistance-lib": "/content-assistance-lib/static-1.6333",
      "content-management-actions-lib": "/content-management-actions-lib/static-1.22761",
      "content-management-data-lib": "/content-management-data-lib/static-1.3907",
      "content-management-restrictions-lib": "/content-management-restrictions-lib/static-1.3632",
      "copilot-plugins": "/copilot-plugins/static-1.6505",
      "copilot-toolkit": "/copilot-toolkit/static-1.6532",
      "cropperjs": "/cropperjs/static-1.10",
      "cssUtils": "/cssUtils/static-1.500",
      "cta-picker": "/cta-picker/static-1.31734",
      "customer-data-objects": "/customer-data-objects/static-1.6443",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.11718",
      "customer-data-properties": "/customer-data-properties/static-1.46010",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.6756",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.11825",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.8552",
      "data-token-picker": "/data-token-picker/static-1.14154",
      "data-token-views": "/data-token-views/static-1.14135",
      "error-messaging-js": "/error-messaging-js/static-1.4121",
      "feedback-loader": "/feedback-loader/static-1.26601",
      "file-manager-components": "/file-manager-components/static-1.18778",
      "FileManagerCore": "/FileManagerCore/static-1.34278",
      "FormsCommonComponents": "/FormsCommonComponents/static-1.81242",
      "foundations-theming": "/foundations-theming/static-1.3149",
      "fuzzy": "/fuzzy/static-1.8",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.1932",
      "growth-payments-core": "/growth-payments-core/static-1.21271",
      "history": "/history/static-4.47",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hs-promise-utils": "/hs-promise-utils/static-1.4357",
      "hub-http-contrib": "/hub-http-contrib/static-1.1996",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3063",
      "HubStyle": "/HubStyle/static-2.10634",
      "icons": "/icons/static-2.592",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.9903",
      "integrations-lib": "/integrations-lib/static-1.10694",
      "interframe": "/interframe/static-3.3628",
      "laboratory-lib": "/laboratory-lib/static-3.6083",
      "layout-data-lib": "/layout-data-lib/static-1.8059",
      "media-bridge-lib": "/media-bridge-lib/static-1.16757",
      "nav-meta": "/nav-meta/static-1.25561",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.42480",
      "onboarding-scopes": "/onboarding-scopes/static-1.5384",
      "onboarding-tours": "/onboarding-tours/static-1.14411",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.3326",
      "outpost": "/outpost/static-1.3187",
      "page-lib": "/page-lib/static-1.16503",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "payment-link-components": "/payment-link-components/static-1.18863",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.3928",
      "pictos": "/pictos/static-7.160",
      "PortalIdParser": "/PortalIdParser/static-2.284",
      "products-ui-components": "/products-ui-components/static-1.35597",
      "property-translator": "/property-translator/static-1.4218",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "raven": "/raven/static-3.4766",
      "react": "/react/static-7.151",
      "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
      "react-colorpicker": "/react-colorpicker/static-2.9075",
      "react-dom": "/react-dom/static-7.85",
      "react-flip-move": "/react-flip-move/static-1.47",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-rhumb": "/react-rhumb/static-1.15408",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-tinymce": "/react-tinymce/static-1.50768",
      "react-transition-group": "/react-transition-group/static-1.7",
      "react-virtualized": "/react-virtualized/static-2.74",
      "redux": "/redux/static-4.16",
      "redux-request-state": "/redux-request-state/static-1.9407",
      "reference-resolvers": "/reference-resolvers/static-1.6976",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.6813",
      "reselect": "/reselect/static-2.16",
      "rich-text-lib": "/rich-text-lib/static-1.17490",
      "rpc-client-utils": "/rpc-client-utils/static-1.3544",
      "sanitize": "/sanitize/static-1.3213",
      "sanitize-text": "/sanitize-text/static-1.7003",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "self-service-api": "/self-service-api/static-1.9035",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.162",
      "SharedLegalStrings": "/SharedLegalStrings/static-1.1310",
      "simple-menus-core": "/simple-menus-core/static-1.13588",
      "simple-menus-lib": "/simple-menus-lib/static-1.15105",
      "smart-content-lib": "/smart-content-lib/static-1.38268",
      "styled-components": "/styled-components/static-2.64",
      "StyleGuideUI": "/StyleGuideUI/static-3.461",
      "superstore": "/superstore/static-1.3597",
      "theme-previewer-lib": "/theme-previewer-lib/static-1.48348",
      "tinymce-config": "/tinymce-config/static-2.49894",
      "tinymce-copilot": "/tinymce-copilot/static-1.11962",
      "tinymce-data": "/tinymce-data/static-1.35979",
      "tinymce-plugins": "/tinymce-plugins/static-1.53008",
      "tinymce-themes": "/tinymce-themes/static-1.51864",
      "transmute": "/transmute/static-2.29",
      "ui-addon-avatars": "/ui-addon-avatars/static-2.8156",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.8772",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.9850",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.9752",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.7722",
      "ui-addon-opt": "/ui-addon-opt/static-4.7463",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4043",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.16083",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.7705",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.9072",
      "ui-product-approvals": "/ui-product-approvals/static-1.23965",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.8893",
      "ui-suspension-banners-lib": "/ui-suspension-banners-lib/static-1.5250",
      "UIComponents": "/UIComponents/static-3.7273",
      "underscore": "/underscore/static-1.8",
      "urlinator": "/urlinator/static-1.3377",
      "usage-tracker": "/usage-tracker/static-1.6297",
      "usage-tracker-core": "/usage-tracker-core/static-1.6147",
      "user-context": "/user-context/static-1.4002",
      "video-embed": "/video-embed/static-1.30530",
      "web-interactives-components": "/web-interactives-components/static-1.11564",
      "web-interactives-data": "/web-interactives-data/static-1.11565",
      "wootric-nps": "/wootric-nps/static-1.5756",
      "xray-recommendation-lib": "/xray-recommendation-lib/static-1.6023",
      "codemirror": "/codemirror/static-5.72",
      "react-codemirror": "/react-codemirror/static-1.9435",
      "enviro": "/enviro/static-4.306",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4306",
      "raven-hubspot": "/raven-hubspot/static-1.5073",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "metrics-js": "/metrics-js/static-1.8459",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2474",
      "moment": "/moment/static-3.26",
      "jquery": "/jquery/static-3.6",
      "chatspot-client-types": "/chatspot-client-types/static-1.8627",
      "chatspot-core": "/chatspot-core/static-1.15770",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.15764",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.5701",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.6697",
      "graphql": "/graphql/static-1.59",
      "magpie-lib": "/magpie-lib/static-1.4498",
      "magpie-types": "/magpie-types/static-1.3958",
      "quartz-core": "/quartz-core/static-1.4801",
      "simple-logging-lib": "/simple-logging-lib/static-1.1867",
      "ts-schema": "/ts-schema/static-1.3154",
      "cms-field-types": "/cms-field-types/static-1.3615",
      "content-embed-lib": "/content-embed-lib/static-1.6182",
      "ExportDialog": "/ExportDialog/static-6.9215",
      "forms-utils-lib": "/forms-utils-lib/static-1.10267",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.8109",
      "payments-embed-points-lib": "/payments-embed-points-lib/static-1.9582",
      "react-dnd-compat": "/react-dnd-compat/static-1.3484",
      "usage-tracker-container": "/usage-tracker-container/static-1.6287",
      "video-data-lib": "/video-data-lib/static-1.29689",
      "videoconference-integration-components": "/videoconference-integration-components/static-1.4981",
      "editor-iframe-lib": "/editor-iframe-lib/static-1.7138",
      "FireAlarmUi": "/FireAlarmUi/static-1.3655",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.3655",
      "layout-dnd-components": "/layout-dnd-components/static-1.10759",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1449",
      "smart-content-core": "/smart-content-core/static-1.37615",
      "social-composer-lib": "/social-composer-lib/static-1.53555",
      "structured-content-lib": "/structured-content-lib/static-1.20526",
      "timezone-utils": "/timezone-utils/static-2.4072",
      "ui-active-theme-content-creator-lib": "/ui-active-theme-content-creator-lib/static-1.32416",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.7598",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.9111",
      "ui-tool-access": "/ui-tool-access/static-1.8886",
      "content-icons-ui": "/content-icons-ui/static-1.1897",
      "react-aria": "/react-aria/static-1.39",
      "FileManagerImages": "/FileManagerImages/static-1.31929",
      "hs-story-utils": "/hs-story-utils/static-1.8220",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2301",
      "floating-ui": "/floating-ui/static-1.29",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.866",
      "framer-motion": "/framer-motion/static-1.41",
      "tanstack-table": "/tanstack-table/static-1.23",
      "ui-fonts": "/ui-fonts/static-1.332",
      "HeadJS": "/HeadJS/static-2.577",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.1939",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.121",
      "i18n-data": "/i18n-data/static-1.197",
      "moment-timezone": "/moment-timezone/static-5.51",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8243",
      "react-dnd-ipeui-backend": "/react-dnd-ipeui-backend/static-1.898",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.23106",
      "jasmine": "/jasmine/static-4.3168",
      "marketplace-embed": "/marketplace-embed/static-1.16844",
      "quartz-core-utils": "/quartz-core-utils/static-1.2449",
      "flux-actions": "/flux-actions/static-1.273",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.9299",
      "rxjs": "/rxjs/static-5.10",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.3517",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.3609",
      "content-media-compositions": "/content-media-compositions/static-2.10419",
      "idb-keyval": "/idb-keyval/static-1.21",
      "immerable": "/immerable/static-1.2977",
      "video-components": "/video-components/static-1.8041",
      "autolinker": "/autolinker/static-3.11",
      "foundations-theming-base": "/foundations-theming-base/static-1.2134",
      "sassPrefix": "/sassPrefix/static-1.131",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.5512",
      "attribution-lib": "/attribution-lib/static-1.37838",
      "campaigns-build-lib": "/campaigns-build-lib/static-1.8196",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3146",
      "reporting-ui-components": "/reporting-ui-components/static-2.59175",
      "ai-rendering-library": "/ai-rendering-library/static-1.5282",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.8948",
      "avatar-components": "/avatar-components/static-1.1261",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.18040",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.51752",
      "commerce-products-lib": "/commerce-products-lib/static-1.5077",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.2938",
      "crm-links": "/crm-links/static-1.4932",
      "crm-message-bus": "/crm-message-bus/static-1.36974",
      "external-options-client-types": "/external-options-client-types/static-1.3103",
      "google-libphonenumber": "/google-libphonenumber/static-1.12",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.2807",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.2950",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3232",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.2894",
      "smart-property-lib": "/smart-property-lib/static-1.941",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "audio-components": "/audio-components/static-1.4488",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "salesImages": "/salesImages/static-1.500",
      "forms-ai-lib": "/forms-ai-lib/static-1.2274",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1632",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.2535",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.4338",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.6667",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.12800",
      "growth-data-modal": "/growth-data-modal/static-1.4054",
      "navigation-components": "/navigation-components/static-1.13924",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.6274",
      "ui-universal-auth": "/ui-universal-auth/static-1.7625",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.3646",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.3985",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.2547",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.14855",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.31634",
      "crm_components": "/crm_components/static-3.86901",
      "crm_data": "/crm_data/static-4.86901",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.34083",
      "customer-data-tracking": "/customer-data-tracking/static-1.5634",
      "dispatcher": "/dispatcher/static-1.112",
      "framework-data-table": "/framework-data-table/static-2.8703",
      "property-description-translator": "/property-description-translator/static-1.2679",
      "csstype": "/csstype/static-1.38",
      "batch-promise": "/batch-promise/static-1.420",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.6787",
      "redux-mock-store": "/redux-mock-store/static-1.8",
      "redux-undo": "/redux-undo/static-1.10",
      "hubspotter-http": "/hubspotter-http/static-1.3603",
      "navigation-messaging": "/navigation-messaging/static-1.3251",
      "feature-store-service-types": "/feature-store-service-types/static-1.3510",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.3517",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.3501",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.11918",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "browser-eslint": "/browser-eslint/static-2.57",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3075",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.5606",
      "persist-promise": "/persist-promise/static-1.2578",
      "hub-http-janus": "/hub-http-janus/static-1.648",
      "general-store": "/general-store/static-6.20",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.7095",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.348",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11240",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.17853",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.5277",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.12987",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.11858",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.14451",
      "marketplace-ui-details": "/marketplace-ui-details/static-1.4351",
      "property-management-iframe": "/property-management-iframe/static-1.8448",
      "trellis-ecosystem": "/trellis-ecosystem/static-1.4717",
      "social-insights-client-types": "/social-insights-client-types/static-1.17865",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.3552",
      "highcharts": "/highcharts/static-8.81",
      "report-customization-components": "/report-customization-components/static-1.8961",
      "reporting-action-components": "/reporting-action-components/static-1.36492",
      "reporting-data": "/reporting-data/static-1.61898",
      "reporting-enablement": "/reporting-enablement/static-1.17353",
      "reporting-snowflake": "/reporting-snowflake/static-1.50519",
      "reporting-visualizations": "/reporting-visualizations/static-1.53975",
      "customer-data-filters": "/customer-data-filters/static-1.47898",
      "reporting-plugins": "/reporting-plugins/static-1.7003",
      "reporting-reports": "/reporting-reports/static-1.61581",
      "highlight.js": "/highlight.js/static-1.45",
      "markdown-it": "/markdown-it/static-1.6",
      "react-table": "/react-table/static-1.15",
      "ui-addon-teams": "/ui-addon-teams/static-1.19824",
      "calling-internal-common": "/calling-internal-common/static-1.30058",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.9905",
      "calling-global-api": "/calling-global-api/static-1.58075",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.59457",
      "products-iframe-lib": "/products-iframe-lib/static-1.3294",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.7480",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.4184",
      "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.4070",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.7181",
      "fsm": "/fsm/static-1.2533",
      "policy-lib": "/policy-lib/static-1.5619",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.7243",
      "final-form": "/final-form/static-1.40",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.1768",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.14964",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.6552",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6214",
      "crm_universal": "/crm_universal/static-1.20577",
      "customer-data-content": "/customer-data-content/static-1.24578",
      "crm_schema": "/crm_schema/static-3.86939",
      "customer-data-email": "/customer-data-email/static-1.15827",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.16516",
      "lodash": "/lodash/static-4.7",
      "customer-data-associations": "/customer-data-associations/static-1.6035",
      "customer-data-rte": "/customer-data-rte/static-1.29177",
      "cv-backend-services": "/cv-backend-services/static-1.1177",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.4055",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.13815",
      "prosemirror": "/prosemirror/static-1.13",
      "qrcode-generator": "/qrcode-generator/static-1.44",
      "quotes-client-types": "/quotes-client-types/static-1.31968",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6711",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.5287",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.9000",
      "immutable-less": "/immutable-less/static-1.3386",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.6826",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.2984",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.5951",
      "react-window": "/react-window/static-1.13",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.8435",
      "ai-studio-lib": "/ai-studio-lib/static-1.5811",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.10335",
      "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.14410",
      "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.8625",
      "property-management-common": "/property-management-common/static-1.734",
      "trellis-story-utils": "/trellis-story-utils/static-1.3376",
      "dashboard-lib": "/dashboard-lib/static-1.76071",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.7496",
      "reporting-client-types": "/reporting-client-types/static-1.1918",
      "data-quality-ui-library": "/data-quality-ui-library/static-1.8289",
      "html-to-image": "/html-to-image/static-1.30",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.7833",
      "crm-object-map": "/crm-object-map/static-1.2022",
      "deep-diff": "/deep-diff/static-1.5",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.3261",
      "calling-error-reporting": "/calling-error-reporting/static-1.30064",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.5324",
      "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.30244",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.2791",
      "sales-views-client-types": "/sales-views-client-types/static-1.3144",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.2775",
      "storybook-react": "/storybook-react/static-1.4",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.3983",
      "utility-belt": "/utility-belt/static-1.1391",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.38333",
      "zustand": "/zustand/static-1.51",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.7161",
      "sequences-lib": "/sequences-lib/static-1.5967",
      "draft-content-plugins": "/draft-content-plugins/static-1.24535",
      "draft-convert": "/draft-convert/static-2.31",
      "draft-extend": "/draft-extend/static-2.46",
      "draft-js": "/draft-js/static-5.37",
      "draft-plugins": "/draft-plugins/static-2.19329",
      "knowledge-content-types": "/knowledge-content-types/static-1.7755",
      "stripe-connect-js": "/stripe-connect-js/static-1.40",
      "apps-service-types": "/apps-service-types/static-1.2920",
      "oauth-service-types": "/oauth-service-types/static-1.3132",
      "automation-ui-action-features": "/automation-ui-action-features/static-1.49964",
      "academy-common-lib": "/academy-common-lib/static-1.9795",
      "crm-component-utils": "/crm-component-utils/static-1.34736",
      "redux-actions": "/redux-actions/static-3.7",
      "crm-index-visualization-object-layout": "/crm-index-visualization-object-layout/static-1.731",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.6384",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.30469",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.33",
      "crm-actions": "/crm-actions/static-1.4904",
      "crm-fe-perf": "/crm-fe-perf/static-1.21832",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3186",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.5824",
      "ads-client-types": "/ads-client-types/static-1.17248",
      "app-users-service-types": "/app-users-service-types/static-1.3366",
      "automation-actions-service-types": "/automation-actions-service-types/static-1.3333",
      "automation-applications-service-types": "/automation-applications-service-types/static-1.2553",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2139",
      "automation-ui-action-fields": "/automation-ui-action-fields/static-1.33261",
      "automation-ui-associations": "/automation-ui-associations/static-1.14847",
      "automation-ui-core": "/automation-ui-core/static-2.16173",
      "automation-ui-enrollment": "/automation-ui-enrollment/static-1.51609",
      "automation-ui-flow-core": "/automation-ui-flow-core/static-1.15562",
      "automation-ui-formula-editor": "/automation-ui-formula-editor/static-1.11715",
      "automation-ui-i18n": "/automation-ui-i18n/static-1.15630",
      "automation-ui-permissions": "/automation-ui-permissions/static-1.14533",
      "automation-ui-references": "/automation-ui-references/static-1.15585",
      "automation-ui-routing": "/automation-ui-routing/static-1.15597",
      "automation-ui-source-apps": "/automation-ui-source-apps/static-1.13319",
      "automation-ui-types": "/automation-ui-types/static-1.14237",
      "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.15639",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.4490",
      "messaging-editing-lib": "/messaging-editing-lib/static-1.40893",
      "routing-ui": "/routing-ui/static-1.16322",
      "skills-lib": "/skills-lib/static-1.25158",
      "task-forms-lib": "/task-forms-lib/static-1.36416",
      "ui-addon-automation-embed": "/ui-addon-automation-embed/static-1.12371",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.3999",
      "academy-service-client": "/academy-service-client/static-1.2688",
      "card-properties-lib": "/card-properties-lib/static-1.39052",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.6425",
      "crm-association-components-lib": "/crm-association-components-lib/static-1.5169",
      "messaging-publishing-lib": "/messaging-publishing-lib/static-1.40845",
      "mobile-messaging-management-lib": "/mobile-messaging-management-lib/static-1.29543",
      "automation-enrollment-service-types": "/automation-enrollment-service-types/static-1.2715",
      "data-ops-fullstory": "/data-ops-fullstory/static-1.4171",
      "workflows-copilot-service-types": "/workflows-copilot-service-types/static-1.1494",
      "messaging-types-lib": "/messaging-types-lib/static-1.40629",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.2916",
      "ably": "/ably/static-1.18",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.3406",
      "conversations-http": "/conversations-http/static-1.3633",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.11479",
      "conversations-message-history": "/conversations-message-history/static-1.9932",
      "conversations-prop-types": "/conversations-prop-types/static-1.6248",
      "conversations-async-data": "/conversations-async-data/static-2.6499",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.7775",
      "conversations-infrastructure": "/conversations-infrastructure/static-1.7763",
      "conversations-thread-data": "/conversations-thread-data/static-1.63031",
      "conversations-thread-view": "/conversations-thread-view/static-1.71762",
      "conversations-visibility-tools": "/conversations-visibility-tools/static-1.4580",
      "svh-tickets-lib": "/svh-tickets-lib/static-1.14093",
      "crm-activity-creator-data": "/crm-activity-creator-data/static-1.41441",
      "customer-data-communicator": "/customer-data-communicator/static-1.40429",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.10918",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.41256",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.10061",
      "framework-listing-lib": "/framework-listing-lib/static-2.22864",
      "industries-core": "/industries-core/static-1.5600",
      "messaging-management-lib": "/messaging-management-lib/static-1.12405",
      "calling-cross-tab-messaging": "/calling-cross-tab-messaging/static-1.18037",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.14833",
      "conversations-routing-lib": "/conversations-routing-lib/static-1.6625",
      "call-widget-addon": "/call-widget-addon/static-2.28182",
      "calling-integration-cross-tab": "/calling-integration-cross-tab/static-1.17870",
      "calling-integration-help-desk": "/calling-integration-help-desk/static-1.19676",
      "calling-ui-library": "/calling-ui-library/static-1.65375",
      "composer-data": "/composer-data/static-1.25811",
      "conversations-inbox-message-history": "/conversations-inbox-message-history/static-1.30219",
      "conversations-platform": "/conversations-platform/static-1.3322",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.20778",
      "zorse-crm-components-lib": "/zorse-crm-components-lib/static-1.5841",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.7347",
      "universal-associations-select": "/universal-associations-select/static-1.9641",
      "crm-display-components": "/crm-display-components/static-1.20486",
      "crm-legacy-global-containers": "/crm-legacy-global-containers/static-1.22618",
      "draft-email-branding-plugin": "/draft-email-branding-plugin/static-2.20464",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.20212",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.13807",
      "integration-settings-components": "/integration-settings-components/static-1.10643",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.3047",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.2811",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.32103",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.34057",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.49708",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.17335",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.13362",
      "project-storage": "/project-storage/static-1.3516",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.65885",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.4108",
      "customer-data-views-management": "/customer-data-views-management/static-1.22371",
      "signup-ui-full-screen-search": "/signup-ui-full-screen-search/static-1.10207",
      "calling-client-interface": "/calling-client-interface/static-1.70614",
      "calling-integration-sdk-support": "/calling-integration-sdk-support/static-1.26096",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.4950",
      "worker-connection-library": "/worker-connection-library/static-1.12247",
      "share-transcript-modal": "/share-transcript-modal/static-1.52688",
      "transcript-sidebar": "/transcript-sidebar/static-1.63043",
      "twilio-voice-sdk": "/twilio-voice-sdk/static-1.51",
      "conversations-calling-message": "/conversations-calling-message/static-1.55155",
      "signup-constants": "/signup-constants/static-1.16333",
      "signup-ui-lego-core": "/signup-ui-lego-core/static-1.18343",
      "viral-links-lib": "/viral-links-lib/static-1.5712",
      "remote-ui": "/remote-ui/static-1.40",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.12741",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.4933",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.51782",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.49724",
      "SafeStorage": "/SafeStorage/static-1.3237",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.96556",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.74599",
      "crm-export-dialog": "/crm-export-dialog/static-1.5120",
      "crm-index-associations-lib": "/crm-index-associations-lib/static-1.5229",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.4482",
      "recording-review-components-lib": "/recording-review-components-lib/static-1.26970",
      "call-summary": "/call-summary/static-1.32767",
      "emoji-regex": "/emoji-regex/static-1.7",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.6888",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.6326"
    },
    "project": "page-editor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};